import "../../styles/template/template.scss";

const BadgeBlock = (props: any) => {
  return <div className={`badge-wrapper ${props.theme}`}>{props.name}</div>;
};

export default BadgeBlock;
